import { render, staticRenderFns } from "./DashItemToggleButton.vue?vue&type=template&id=7620cf5e&scoped=true"
import script from "./DashItemToggleButton.vue?vue&type=script&lang=js"
export * from "./DashItemToggleButton.vue?vue&type=script&lang=js"
import style0 from "./DashItemToggleButton.vue?vue&type=style&index=0&id=7620cf5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7620cf5e",
  null
  
)

export default component.exports